export default class DataLayer {
  public static push(data: { event: string, [key: string]: unknown }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
}
